import actionCreator from 'helpers/actionCreator'

export const CREATE_CAMERA = 'CREATE_CAMERA'
export const REMOVE_CAMERA = 'REMOVE_CAMERA'
export const DESTROY_CAMERA = 'DESTROY_CAMERA'
export const ADD_CAMERA = 'ADD_CAMERA'
export const UPDATE_CAMERA = 'UPDATE_CAMERA'
export const BATCH_UPDATE_CAMERA = 'BATCH_UPDATE_CAMERA'
export const CHANGE_CAMERA = 'CHANGE_CAMERA'
export const SET_CAMERA_TO_ACTIVE = 'SET_CAMERA_TO_ACTIVE'
export const CHANGE_CAMERA_MODEL = 'CHANGE_CAMERA_MODEL'
export const SET_CAMERA_MODEL = 'SET_CAMERA_MODEL'
export const REMOVE_CAMERA_MODEL = 'REMOVE_CAMERA_MODEL'
export const CLEAR_MODEL_REFERENCES = 'CLEAR_MODEL_REFERENCES'
export const UPDATE_PPF_HOVER = 'UPDATE_PPF_HOVER'
export const DUPLICATE_CAMERA = 'DUPLICATE_CAMERA'
export const FAVORITE_MODEL = 'FAVORITE_MODEL'
export const UNFAVORITE_MODEL = 'UNFAVORITE_MODEL'
export const CLEAR_CAMERAS = 'CLEAR_CAMERAS'
export const COPY_CAMERA = 'COPY_CAMERA'
export const NEXT_CAMERA = 'NEXT_CAMERA'
export const ADD_RECENT_MODEL = 'ADD_RECENT_MODEL'

export const createCameraAction = actionCreator(CREATE_CAMERA, 'location')
export const removeCameraAction = actionCreator(REMOVE_CAMERA, 'id', 'idToSwitchTo')
export const destroyCameraAction = actionCreator(DESTROY_CAMERA, 'id')
export const addCameraAction = actionCreator(ADD_CAMERA, 'id', 'location', 'distance')
export const updateCameraAction = actionCreator(UPDATE_CAMERA, 'key', 'value', 'id')
export const batchUpdateCameraAction = actionCreator(BATCH_UPDATE_CAMERA, 'keys', 'values', 'id')
export const changeCameraAction = actionCreator(CHANGE_CAMERA, 'id')
export const setCameraToActiveAction = actionCreator(SET_CAMERA_TO_ACTIVE, 'id')
export const changeCameraModelAction = actionCreator(CHANGE_CAMERA_MODEL, 'model', 'aov', 'applySingle')
export const setCameraModelAction = actionCreator(SET_CAMERA_MODEL, 'model', 'aov')
export const removeCameraModelAction = actionCreator(REMOVE_CAMERA_MODEL)
export const clearModelReferencesAction = actionCreator(CLEAR_MODEL_REFERENCES, 'id')
export const updatePPFHoverAction = actionCreator(UPDATE_PPF_HOVER, 'latLng')
export const duplicateCameraAction = actionCreator(DUPLICATE_CAMERA, 'id', 'location', 'imagerId', 'lensIds', 'fixedLensIds')
export const favoriteModelAction = actionCreator(FAVORITE_MODEL, 'id', 'controllerModel')
export const unfavoriteModelAction = actionCreator(UNFAVORITE_MODEL, 'id', 'controllerModel')
export const clearCamerasAction = actionCreator(CLEAR_CAMERAS)
export const copyCameraAction = actionCreator(COPY_CAMERA, 'id')
export const nextCameraAction = actionCreator(NEXT_CAMERA)
export const addRecentModelAction = actionCreator(ADD_RECENT_MODEL, 'modelId', 'now', 'controllerModel')



// WEBPACK FOOTER //
// ./src/actions/cameraActions.js